import { ErrorMessage } from "formik";
import React from "react";
import ErrorIcon from "../../icons/ErrorIcon";

const FormField = ({ label, name, children, hideErrorMessage = false }) => (
  <div className="pt-2">
    <label htmlFor={name} className="block mb-2 font-medium">
      {label}
    </label>
    {children}
    {!hideErrorMessage && (
      <ErrorMessage
        name={name}
        component={(props) => (
          <div className="mt-3 flex justify-start items-start">
            <ErrorIcon />
            <div className="text-red-500 text-sm">{props.children}</div>
          </div>
        )}
      />
    )}
  </div>
);

export default FormField;
